import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { getAccountEmployeeTypeByAccountEmployeeTypeIdAsync, deleteAccountEmployeeTypeAsync, checkedState, unCheckedState, checkedAllState, unCheckedAllState, updateAccountEmployeeTypeAsync,updateSorting } from "./EmployeeTypeSlice";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import CustomPagination from "../../../common/Pagination";
import { KTIcon } from '../../../_metronic/helpers';
import { ShowToast } from '../../../common/Toastr';
import clsx from "clsx";
import { setItemStatus,getValueFromResource } from '../../../common/timeLiveFunction';

const itemClass = 'ms-1 ms-lg-0';

export const EmployeeTypeItem = (props: any) => {
    const { employeeTypeList, modelRef, t, onopenModal, oncloseModal, IsEdit, IsDelete } = props;
    const { sortOrder, sortColumn,pageSize } = useAppSelector((state) => state.employeeType);
    const { manageTerminologyList } = useAppSelector((state) => state.globalState);
    const dispatch = useAppDispatch();
    const { isLoading } = useAppSelector((state) => state.employeeType);

    const handleCheckboxChange = (e: any, rowId: any) => {

        if (e.target.checked) {
            dispatch(checkedState(rowId))
        } else {
            dispatch(unCheckedState(rowId))
        }
    };
    const onEditClick = (AccountEmployeeTypeId: number) => {
        dispatch(getAccountEmployeeTypeByAccountEmployeeTypeIdAsync(AccountEmployeeTypeId))
            .unwrap()
            .then((originalPromiseResult) => {
                onopenModal();
            })
            .catch((rejectedValueOrSerializedError) => {

            })
    }

    const onDeleteClick = (AccountEmployeeTypeId: number) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteAccountEmployeeTypeAsync(AccountEmployeeTypeId))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult.StatusCode === "200" ?
                                ShowToast("Employee type deleted Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                            ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                        })
                }
            })
            .catch((error) => {

            });
    }

    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState());
        } else {
            dispatch(unCheckedAllState());
        }
    };

    const handleIsDisabledChange = (e: any, AccountEmployeeType: any) => {
        const { checked } = e.target;
        const foundIndex = employeeTypeList.findIndex((item: any) => item.AccountEmployeeTypeId === AccountEmployeeType.AccountEmployeeTypeId);
        if (foundIndex !== -1) {
            const foundItem = employeeTypeList[foundIndex];
            const { isSelected, IsVendor, ...updatedItem } = foundItem;
            console.log('IsVendor', IsVendor);
            // const isvendorvalue = IsVendor === "yes" || true ? true : false;
            // updatedItem.IsVendor = isvendorvalue
            updatedItem.IsDisabled = checked;
            const modifiedList = [...employeeTypeList.slice(0, foundIndex), updatedItem, ...employeeTypeList.slice(foundIndex + 1)];
            dispatch(updateAccountEmployeeTypeAsync(updatedItem))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "200" ?
                        ShowToast("Employee type Update Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }
    }

    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        dispatch(updateSorting({
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "pageSize": pageSize,
            "pageNo": 1
        }));
    }
    return (
        <>
        
            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                <thead>
                    <tr className="thHeading align-middle">
                    <th style={{width:'15%'}}>
                        {/* {t('Active / Inactive')} */}
                        {getValueFromResource('Active / Inactive',dispatch, t)}
                    {sortColumn === 'IsDisabled' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}</th>                   
                                <th style={{width:'70%'}}>
                                    {/* {t('Employee Type')} */}
                                    {getValueFromResource('Employee Type',dispatch, t)}
                                   {sortColumn === 'AccountEmployeeType' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "AccountEmployeeType") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "AccountEmployeeType") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "AccountEmployeeType") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "AccountEmployeeType") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        {/* {IsEdit &&
                            <th className='w-15'>{t('Active / Inactive')}</th>
                        } */}
                        <th className='w-10 text-center'></th>
                    </tr>
                </thead>
                <tbody>
                    {employeeTypeList.length > 0 && employeeTypeList.map((employeeTypeDetail: any, i: any) => (
                        <tr key={i}>
                            <td>
                                <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(employeeTypeDetail.IsDisabled === 'No' ? "Active" : "InActive"))}>
                                    {employeeTypeDetail.IsDisabled === 'No' ? "Active" : "InActive"}
                                </span>
                            </td>
                            <td className='text-gray-800  text-hover-primary custom-pointer-cursor ' onClick={IsEdit ? () => onEditClick(employeeTypeDetail.AccountEmployeeTypeId) : undefined}>
                                <span className="   d-block "
                                >{employeeTypeDetail.AccountEmployeeType}</span>
                            </td>

                            {/* {IsEdit &&
                                <td className='text-center'>

                                    <div className="form-check form-switch form-check-custom">
                                        <input
                                            type="checkbox"
                                            className="form-check-input custom-padding-right h-15px w-30px"
                                            id="IsDisabled"
                                            checked={employeeTypeDetail.IsDisabled === 'Yes' ? true : false}
                                            onChange={(e) => { handleIsDisabledChange(e, employeeTypeDetail) }}
                                        />
                                        
                                    </div>

                                </td>
                            } */}
                             <td className='text-center' >
                             <Dropdown
                                    style={{ marginLeft: 1 }}
                                    className={clsx('cursor-pointer symbol')}
                                    data-kt-menu-attach='parent'
                                    data-kt-menu-placement='bottom-end'
                                >
                                    <Dropdown.Toggle
                                        variant="transparent"
                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                        data-tooltip-id="tooltip-Description"
                                        data-tooltip-content=
                                        // {t("More")}
                                        {getValueFromResource('More',dispatch, t)}
                                        data-tooltip-place="top"
                                    >
                                        <i className="bi bi-three-dots fs-7"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                                    {IsEdit &&
                                                        <>
                                                            <div className='menu-hover-bg-sec'>
                                                                <Dropdown.Item
                                                                    className="menu-item me-lg-0 "
                                                                    onClick={() => {
                                                                        dispatch(getAccountEmployeeTypeByAccountEmployeeTypeIdAsync(employeeTypeDetail.AccountEmployeeTypeId))
                                                                            .unwrap()
                                                                            .then((originalPromiseResult) => {
                                                                                onopenModal();
                                                                            })
                                                                            .catch((rejectedValueOrSerializedError) => {
                                                                            })
                                                                    }}
                                                                >
                                                                    <span className="menu-icon custom-menu">
                                                                        <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                            <span className="path1"></span>
                                                                            <span className="path2"></span>
                                                                        </i>
                                                                    </span>
                                                                    <span className="menu-title custom-menu-fontsize">
                                                                        {/* {`${t('Edit')}`} */}
                                                                        {getValueFromResource('Edit',dispatch, t)}

                                                                        </span>
                                                                </Dropdown.Item>
                                                            </div>
                                                        </>
                                                    }
                                                    {IsDelete && IsEdit && (employeeTypeDetail.MasterEmployeeTypeId === null || employeeTypeDetail.MasterEmployeeTypeId === 0) &&
                                                        <div className='separator mb-1 mt-1 opacity-75 '></div>
                                                    }
                                                    {/* {IsDelete && */}
                                                    {IsDelete === true && (employeeTypeDetail.MasterEmployeeTypeId === null || employeeTypeDetail.MasterEmployeeTypeId === 0) &&
                                                        <>
                                                            <div className='menu-hover-bg-danger'>
                                                                <Dropdown.Item
                                                                    className="menu-item me-lg-0 "
                                                                    onClick={() => { onDeleteClick(employeeTypeDetail.AccountEmployeeTypeId) }}>
                                                                    <span className="menu-icon  custom-menu">
                                                                        <i className="bi bi-trash fs-6 delete-menu-icon-color " >
                                                                            <span className="path1"></span>
                                                                            <span className="path2"></span>
                                                                        </i>
                                                                    </span>
                                                                    <span className="menu-title   delete-menu custom-menu-fontsize"  >
                                                                        {/* {`${t('Delete')}`} */}
                                                                        {getValueFromResource('Delete',dispatch, t)}

                                                                        </span>
                                                                </Dropdown.Item>
                                                            </div>
                                                        </>
                                                    }
                                                </Dropdown.Menu>
                                            </Dropdown>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {employeeTypeList.length === 0 &&
                                    <div className=''>
                                        <p className='noDataFound'>
                                            {/* {t('No Record Found')} */}
                                            {getValueFromResource('No Record Found',dispatch, t)}
                                            </p>
                                    </div>
                                }
        </>
    )
}


export default EmployeeTypeItem